export default function TestimonialsSection() {
  const testimonials = [
    {
      quote: 'Brand Capital ha trasformato il nostro approccio al valore del marchio. Ora il brand è un asset patrimoniale riconosciuto e gestito strategicamente.',
      author: 'Davide Malferrari',
      role: 'CEO, Mafin Group',
      avatar: 'https://public.readdy.ai/ai/img_res/f2a7ebccbba88da98fe74537429bf435.jpg',
    },
    {
      quote: 'La perizia Brand Capital è stata determinante per la negoziazione con l\'investitore. Una valutazione tecnica e difendibile che ha fatto la differenza.',
      author: 'Michele Vecchiato',
      role: 'CEO, NMG Italia',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Italian%20male%20CEO%20executive%20portrait%20in%20elegant%20business%20setting%2C%20confident%20business%20leader%20in%20sophisticated%20attire%20with%20blue%20and%20grey%20professional%20background%2C%20premium%20executive%20headshot%20with%20refined%20minimalist%20style%2C%20institutional%20corporate%20portrait%20with%20professional%20atmosphere&width=200&height=200&seq=testimonial-michele-001&orientation=squarish',
    },
    {
      quote: 'La governance patrimoniale del marchio ci ha permesso di proteggere il brand di famiglia e strutturare il passaggio generazionale in modo efficiente.',
      author: 'Anamaria Barbosanu',
      role: 'CEO, Business Network Linker',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20CEO%20entrepreneur%20portrait%20in%20premium%20corporate%20environment%2C%20confident%20businesswoman%20executive%20in%20elegant%20formal%20attire%20with%20blue%20and%20grey%20professional%20background%2C%20sophisticated%20business%20leader%20headshot%20with%20refined%20minimalist%20style%2C%20luxury%20corporate%20portrait%20with%20institutional%20atmosphere&width=200&height=200&seq=testimonial-anamaria-001&orientation=squarish',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#F8F9FA] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#0B1F3B]/5 rounded-full mb-6">
            <span className="text-sm font-semibold text-[#0B1F3B]">Testimonianze</span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-6 leading-tight">
            Cosa Dicono i Nostri Clienti
          </h2>
          <p className="text-lg text-[#1C1C1C]/80 max-w-3xl mx-auto leading-relaxed">
            Imprenditori e professionisti che hanno capitalizzato il valore del loro brand con Brand Capital
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-lg border border-[#0B1F3B]/10 hover:shadow-xl transition-all"
            >
              <div className="mb-6">
                <i className="ri-double-quotes-l text-4xl text-[#C9A861]/30"></i>
              </div>
              <p className="text-base text-[#1C1C1C]/80 mb-8 leading-relaxed italic">
                {testimonial.quote}
              </p>
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.author}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0B1F3B]">{testimonial.author}</p>
                  <p className="text-xs text-[#1C1C1C]/60">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
